import { PolicyViewerScreen } from '@/features/policy-acceptance';

export default function TermsOfServiceRoute() {
  return <PolicyViewerScreen policyType="TERMS_OF_SERVICE" />;
}
